import "desvg";
import templates from "@/js/templates/front";
import components from "@/js/components";
import pages from "@/js/pages";
import LoadContents from "@/js/plugins/LoadContents";
import forms from "@/js/forms";


window.addEventListener("DOMContentLoaded", async () => {
    deSVG("img[inline]", true);
    templates();
    components();
    pages();
    new LoadContents();
    forms();
});
